import { useTranslation } from "@next-platform/client-common-core";
import { SubCapabilityKey, useApplicationCapabilitiesAllowed } from "@next-platform/client-common-core/infra/application/capabilities";
import { IconVariants } from "@next-platform/client-common-spicy-ui";
import { useMemo } from "react";

import { CharacterCardDropdownActions } from "@/components/search/types";

type UseDiscoverRowDropdownMenuParameters = {
  characterId: string;
  onAction: (action: CharacterCardDropdownActions, characterId: string) => void;
  isAuthenticated: boolean;
  canBlockCreator: boolean;
};

const useDiscoverRowDropdownMenu = ({ characterId, onAction, isAuthenticated, canBlockCreator }: UseDiscoverRowDropdownMenuParameters) => {
  const { t } = useTranslation();
  const isCharacterShareLinkAllowed = useApplicationCapabilitiesAllowed(SubCapabilityKey.CharacterShareLink);

  return useMemo(() => {
    const shareAction = isCharacterShareLinkAllowed
      ? [
          {
            label: t("chatbotCard:dropdown.share"),
            icon: IconVariants.SHARE,
            onPress: () => onAction(CharacterCardDropdownActions.SHARE, characterId),
          },
        ]
      : [];

    return [
      ...shareAction,
      {
        label: t("chatbotCard:dropdown.report"),
        icon: IconVariants.FLAG,
        onPress: () => onAction(CharacterCardDropdownActions.REPORT, characterId),
      },
      {
        label: t("chatbotCard:dropdown.blockCreator"),
        icon: IconVariants.USER_CANCEL,
        onPress: () => onAction(CharacterCardDropdownActions.BLOCK, characterId),
        isHidden: !canBlockCreator,
      },
      {
        label: t("chatbotCard:dropdown.lessLikeThis"),
        icon: IconVariants.CIRCLE_MINUS,
        onPress: () => onAction(CharacterCardDropdownActions.LESS_LIKE_THIS, characterId),
        isHidden: !isAuthenticated,
      },
    ];
  }, [canBlockCreator, characterId, isAuthenticated, isCharacterShareLinkAllowed, onAction, t]);
};

export default useDiscoverRowDropdownMenu;
